<template>
  <g class="lines">
    <line
      v-for="(datum, index) in d"
      :key="'circle-' + index"
      :class="[
        'line',
        {
          selected:
            p.tooltipMove &&
            p.tooltipMove.datum &&
            p.tooltipMove.datum[c.xAxis] == datum[c.xAxis],
        },
        {
          lineNotHovered:
            hoveredStacked !== serie.key && hoveredStacked !== null,
        },
      ]"
      :x1="p.scaleX(datum[c.xAxis])"
      :x2="p.scaleX(datum[c.xAxis])"
      :y1="p.scaleY(datum[serie.key])"
      :y2="
        previousSerie ? p.scaleY(datum[previousSerie.key]) : p.scaleY(p.minY)
      "
      stroke-width="2"
      stroke="var(--primary-yellow)"
      opacity="1"
    />
  </g>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["p", "c", "d", "serie", "previousSerie", "serieIndex"],
  computed: {
    ...mapGetters({
      hoveredStacked: "ui/hoveredStacked",
    }),
  },
};
</script>

<style lang="scss" scoped>
.lines {
  .line {
    transition: opacity 0.3s ease;
    &.selected {
    }

    &.lineNotHovered {
      opacity: 0.5;
    }
  }
  .label {
    text-anchor: middle;
    fill: var(--primary-yellow);
    @include number-S;

    &.hidden {
      display: none;
    }
    &.selected {
      display: block;
    }
  }
}
</style>
